function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["className", "ellipsis", "index", "listboxPadding", "listboxRef", "look", "onClick", "onSelected", "option", "selectedIndex"],
  _excluded2 = ["look"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useRef, useEffect, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import { OptionLooks } from "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import { baseListItemStyle } from "../../../../styles/styled-components/listitem.js";
import { mediaPrefersReducedMotion } from "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import { getOptionTheme } from "../../../../styles/styled-components/option.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import { truncateText } from "../../../../styles/styled-components/text.js";
import "../../../../styles/styled-components/tooltip.js";
import { BaseOption } from "../base-option/base-option.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardOption = function BaseStandardOption(props) {
  var _classnames;
  var className = props.className,
    ellipsis = props.ellipsis,
    index = props.index,
    listboxPadding = props.listboxPadding,
    listboxRef = props.listboxRef,
    look = props.look,
    onClick = props.onClick,
    onSelected = props.onSelected,
    option = props.option,
    selectedIndex = props.selectedIndex,
    otherProps = _objectWithoutProperties(props, _excluded);
  var children = option.children,
    disabled = option.disabled,
    key = option.key,
    label = option.label,
    placeholder = option.placeholder;
  var selected = index === selectedIndex;
  var ref = useRef(null);
  useEffect(function () {
    if (listboxRef && listboxRef.current && ref.current && selected) {
      var offsetHeight = listboxRef.current.offsetHeight;
      var offsetHeightHalf = Math.ceil(offsetHeight / 2);
      var offsetTop = ref.current.offsetTop;
      var offset = offsetTop - offsetHeightHalf;
      var top = listboxPadding ? offset + listboxPadding * 2 : offset;
      /**
      * If you change `scroll` `behavior`, also change `scrollToIndex` `behavior` in `StandardListbox`
      */
      listboxRef.current.scroll({
        behavior: 'auto',
        top: top
      });
    }
  }, [selected]); // eslint-disable-line react-hooks/exhaustive-deps
  return /*#__PURE__*/React.createElement(BaseOption, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-option__standard': true,
      'bf-option__standard--ellipsis': ellipsis,
      'bf-option__standard--disabled': disabled
    }, _defineProperty(_classnames, "bf-option__standard--look-".concat(look), look), _defineProperty(_classnames, 'bf-option__standard--placeholder', !!placeholder), _defineProperty(_classnames, 'bf-option__standard--selected', selected), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    disabled: disabled,
    id: key.toString(),
    label: label,
    onClick: disabled ? undefined : function (e) {
      onSelected(index);
      if (onClick) {
        onClick(e);
      }
    },
    ref: ref,
    selected: selected
  }), index === 0 && placeholder || children);
};
var Option = styled(BaseStandardOption)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  cursor: pointer;\n  display: block;\n  padding: 10px;\n  ", "\n  ", "\n  ", "\n\n  &[aria-disabled='true'] {\n    cursor: not-allowed;\n  }\n"])), baseListItemStyle, mediaPrefersReducedMotion, function (_ref) {
  var look = _ref.look;
  return getOptionTheme({
    look: look
  });
}, function (_ref2) {
  var ellipsis = _ref2.ellipsis;
  return ellipsis ? truncateText() : '';
});
/**
 * The `role="option"` is used to identify selections a user can make within a `role="listbox"`.
 *
 * Selected options have `aria-selected="true"`. Disabled options have `aria-selected="false"`
 * and `aria-disabled="true"`.
 *
 * https://www.w3.org/TR/wai-aria-1.2/#option
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/option_role
 *
 * @param props StandardOptionProps
 * @returns FunctionComponent<StandardOptionProps>
 */
var StandardOption = function StandardOption(props) {
  var _props$look = props.look,
    look = _props$look === void 0 ? OptionLooks.Default : _props$look,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Option, _extends({}, otherProps, {
    look: look
  })));
};
export { BaseStandardOption, StandardOption };